import { getLang, urlHelper } from "helpers/themeHelpers";

export const linkToSiteMapPage = () => {
  const locale = getLang();
  return `/${locale}/site-map`;
};

export const citiesLinks = (city) => {
  const locale = getLang();
  return `/${locale}/${urlHelper(city)}`;
};
